
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Uterine_sarcoma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Uterine_sarcoma.vue